var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('v-icon',{attrs:{"dark":""}},[_vm._v(_vm._s(_vm.done?'done':'brush'))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }